var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9577 0.332386C11.8725 0.136363 11.6765 0 11.4549 0H0.545776C0.324185 0 0.128162 0.136363 0.0429347 0.332386C-0.0422926 0.536932 0.000321041 0.775568 0.162253 0.928977L4.36396 5.13068V9.27273C4.36396 9.41761 4.42362 9.55398 4.52589 9.65625L6.70771 11.8381C6.80998 11.9489 6.94634 12 7.09123 12C7.15941 12 7.23612 11.983 7.3043 11.9574C7.50032 11.8722 7.63668 11.6761 7.63668 11.4545V5.13068L11.8384 0.928977C12.0003 0.775568 12.0429 0.536932 11.9577 0.332386Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c194a36f7688f85545a255cecbb22be0.svg";
export { ForwardRef as ReactComponent };